// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import router from './router';
import 'babel-polyfill';

//引入element-ui组件和css
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import App from './App';

//use
Vue.use(ElementUI);
//Vue.use(Vuex)

//引入vuex
import store from './store';
//引入axios
import axios from 'axios';
Vue.prototype.$ajax = axios;

//引入mock
import './mock';

import './permission'; //权限

//创建全局组件
import header from './components/Header'; /*页面头部*/
import footer from './components/Footer'; /*页面尾部*/
Vue.component('my-header', header);
Vue.component('my-footer', footer);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store, //使用store
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js